export default __webpack_public_path__ + "static/media/firebase.a5f9f1fd.png";